module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('container', [(_vm.$isDevMode()) ? _c('div', {
    staticClass: "dev-tools",
    staticStyle: {
      "margin-bottom": "20px",
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn--danger",
    on: {
      "click": _vm.deleteAllRaces
    }
  }, [_vm._v("Dev: Delete All")])]) : _vm._e(), _vm._v(" "), _c('header', {
    staticClass: "live-run-inner"
  }, [(_vm.racesInProgress.length !== 0) ? _c('race-list', {
    attrs: {
      "subtitle": "in progress",
      "races": _vm.racesInProgress
    },
    on: {
      "delete": _vm.handleDeleteRace
    }
  }) : _vm._e(), _vm._v(" "), _c('race-list', {
    attrs: {
      "subtitle": "to start",
      "races": _vm.racesToStart,
      "message-empty-list": "You don't have upcoming races."
    },
    on: {
      "delete": _vm.handleDeleteRace
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25e608aa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveRun/LiveRun.vue
// module id = 1644
// module chunks = 2